import script from "./InternalNotesCard.vue?vue&type=script&setup=true&lang=js"
export * from "./InternalNotesCard.vue?vue&type=script&setup=true&lang=js"

import "./InternalNotesCard.vue?vue&type=style&index=0&id=3514228e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3514228e"]])

export default __exports__